import React from 'react'
import PropTypes from 'prop-types'
import glamorous from 'glamorous'
import { css } from 'glamor'
import { Divider, Button } from '@paypalcorp/pp-react'
import getContent from 'pp-react-l10n'
// import { getFormattedAmount } from '../../shared/amount-utils'
import QuantityWidget from '../../shared/components/quantity-widget'
import '@paypalcorp/pp-vx/dist/components/tile/tile.css'

const l10n = getContent('pages/shops/cart')

import {
  smallAndBigger,
  phoneLandscapeMaxAndSmaller,
  SIZE_SMALL,
} from 'lib/styles/media-queries'

const Container = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})

const CartContent = glamorous.div({
  [phoneLandscapeMaxAndSmaller]: {
    width: '100%',
    height: '80vh',
    justifyContent: 'space-between',
  },
  width: '500px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'space-between',
})

const ProductDetails = glamorous.div({
  marginTop: '35px',
  marginBottom: '10px',
  display: 'flex',
  alignItems: 'center',
  '& .productName': {
    color: 'inherit',
    fontWeight: 'normal',
    fontFamily: 'inherit',
    marginLeft: '20px',
    marginRight: '10px',
    fontSize: '1.15rem',
  },
})

const ProductImage = glamorous.img({
  width: '50px',
  height: '50px',
  borderRadius: '15px',
  [smallAndBigger]: {
    width: '60px',
    height: '60px',
  },
})

// const TotalPriceShipping = glamorous.div({
//   display: 'flex',
//   justifyContent: 'space-between',
// })

const ButtonDiv = glamorous.div({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [smallAndBigger]: {
    marginTop: '50px',
  },
})

const ButtonStyles = css({
  width: '100%',
  marginBottom: '10px',
  [smallAndBigger]: {
    width: '75%',
  },
})

Cart.propTypes = {
  cart: PropTypes.object,
  shippingTotal: PropTypes.number,
  currencyCode: PropTypes.string,
}

function Cart(props) {
  const {
    shopsBuyerState: {
      deleteItemFromCart = () => {},
      // addItemtoCart = () => {},
      // decrementQuantityFromCart = () => {},
      getTotalCartCount = () => {},
      state: { cart = {} },
    } = {},
  } = props

  const handleRemove = (shopHandle, productId) => {
    deleteItemFromCart(shopHandle, productId)
  }

  // const handleQuantityChange = (
  //   updatedQuantity,
  //   changeType,
  //   productId,
  //   shopHandle,
  // ) => {
  //   if (changeType === -1) {
  //     decrementQuantityFromCart(shopHandle, productId)
  //   }
  //   if (changeType === 1) {
  //     addItemtoCart(shopHandle, cart[shopHandle])
  //   }
  // }

  // const formattedShippingTotal = getFormattedAmount({
  //   amount: Object.values(cart)[0][0].shippingFee.toString(),
  //   currencyCode: Object.entries(cart)[0].currencyCode,
  //   symbolIsoCurrency: true,
  // })

  // const formattedTotalPrice = getFormattedAmount({
  //   amount: Object.values(cart)[0][0].productPrice.toString(),
  //   currencyCode: Object.entries(cart)[0].currencyCode,
  //   symbolIsoCurrency: true,
  // })

  const loginCheckoutPage = e => {
    e.preventDefault()
    // props.history.push(`TODO: loginCheckout URL`)
  }

  const guestCheckoutPage = e => {
    e.preventDefault()
    // props.history.push(`TODO: guestCheckout URL`)
  }

  return (
    <Container>
      <CartContent>
        <div>
          <div
            className={
              window.screen.width < SIZE_SMALL
                ? ''
                : 'ppvx_tile ppvx_tile--card'
            }
          >
            {l10n('cartHeading')} {getTotalCartCount()}
            {cart &&
              Object.entries(cart).map(([shopHandle, values]) => {
                return values.map((cartItem, index) => {
                  return (
                    <div key={index}>
                      <>
                        <ProductDetails key={cartItem.productId}>
                          <ProductImage
                            alt={cartItem.productTitle}
                            src={cartItem.photoUrl}
                          />
                          <div className="productName">
                            {cartItem.productTitle}
                          </div>
                        </ProductDetails>
                        <QuantityWidget
                          productId={cartItem.productId}
                          price={cartItem.productPrice}
                          availableItems={cartItem.availableItems}
                          currencyCode={cartItem.currencyCode}
                          quantity={cartItem.quantity}
                          // onQuantityChange={handleQuantityChange}
                          showRemoveText={true}
                          availableText=""
                          handleRemove={handleRemove}
                          // updateTotalPrice={true}
                          shopHandle={shopHandle}
                        />
                      </>
                      {window.screen.width >= SIZE_SMALL &&
                      getTotalCartCount() < 2 ? null : (
                        <Divider />
                      )}
                    </div>
                  )
                })
              })}
            {/* <TotalPriceShipping style={{ marginBottom: '20px' }}>
              <div>{l10n('shippingTotalText')}</div>
              <div>{formattedShippingTotal}</div>
            </TotalPriceShipping>
            <TotalPriceShipping>
              <div>
                <strong>{l10n('totalPrice')}</strong>
              </div>
              <div>{formattedTotalPrice}</div>
            </TotalPriceShipping>
            {window.screen.width < SIZE_SMALL ? <Divider /> : null} */}
          </div>
        </div>
        <ButtonDiv>
          <Button
            theme="v2"
            branded
            onClick={loginCheckoutPage}
            className={`${ButtonStyles}`}
          >
            {l10n('loginCheckout')}
          </Button>
          <Button onClick={guestCheckoutPage} className={`${ButtonStyles}`}>
            {l10n('guestCheckout')}
          </Button>
        </ButtonDiv>
      </CartContent>
    </Container>
  )
}

export default Cart
